import { IIntegrationPartnerUserDto } from '../../interfaces/integration-partner/IIntegrationPartnerUserDto';
import { cryptoPortfolioService } from '../httpService/cryptoPorfolio.service';

export async function tryGetAllIntegrationPartners(page: number, pageSize: number) {
    return await cryptoPortfolioService.get('/integrationpartner/getall', { params: { page, pageSize } });
}

export async function tryGetIntegrationPartnerById(id: string) {
    return await cryptoPortfolioService.get(`/integrationpartner/getbyid/${id}`);
}

export async function tryCreateIntegrationPartner(dto: IIntegrationPartnerUserDto) {
    return await cryptoPortfolioService.post('/integrationpartner/create', dto);
}

export async function tryUpdateIntegrationPartner(dto: IIntegrationPartnerUserDto) {
    return await cryptoPortfolioService.put('/integrationpartner/update', dto);
}

export async function tryRemoveIntegrationPartner(id: string) {
    return await cryptoPortfolioService.delete(`/integrationpartner/delete/${id}`);
}

export async function tryToggleIntegrationPartnerIsActive(id: string) {
    return await cryptoPortfolioService.patch(`/integrationpartner/toggleisactive/${id}`);
}
